import React from "react"

function Cross({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.8783 27.2882C28.0408 27.4507 28.0408 27.7149 27.8783 27.8774C27.7966 27.9591 27.69 27.9991 27.5833 27.9991C27.4766 27.9991 27.37 27.9582 27.2883 27.8774L18 18.5891L8.71163 27.8782C8.62996 27.9599 8.5233 27.9999 8.41663 27.9999C8.30996 27.9999 8.2033 27.9591 8.12163 27.8782C7.95913 27.7157 7.95913 27.4516 8.12163 27.2891L17.4108 17.9999L8.12163 8.71158C7.95913 8.54824 7.95913 8.28491 8.12163 8.12158C8.28413 7.95824 8.5483 7.95908 8.71163 8.12158L18 17.4107L27.2883 8.12158C27.4508 7.95908 27.715 7.95908 27.8775 8.12158C28.04 8.28408 28.04 8.54824 27.8775 8.71074L18.5891 17.9999L27.8783 27.2882Z"
        fill="#003E4C"
      />
    </svg>
  )
}
export default Cross
